import { Import, ImportBase } from "PFTypes";
import { createContext, useContext } from "react";
import { JsonObject } from "type-fest";

import { ImportModalPageType } from "../constants/import_modal_page";

export type ImportModalContextData<T extends ImportBase = Import> = {
  currentPage: ImportModalPageType;
  setCurrentPage: (newPage: ImportModalPageType) => void;
  search?: string;
  setSearch: (term: string) => void;
  importData: T | null;
  setImportData: (importData: T) => void;
  csvTemplate?: JsonObject | string;
};

export const ImportModalContext = createContext<ImportModalContextData<any> | null>(null);

export const useImportModalContext = <T extends ImportBase = Import>() => {
  const context = useContext(ImportModalContext) as ImportModalContextData<T> | null;
  if (!context) {
    throw new Error("useImportModalContext must be used within a ImportModalContextProvider");
  }
  return context;
};
